<template>
  <div class="live-data-page">
    <keep-alive>
      <DataView
        ref="dataView"
        :podData="podData"
        :screenWidth="screenWidth"
        :connectionStatus="connectionStatus"
        v-if="activeView === 'live_data_view'"
      />
    </keep-alive>
    <keep-alive>
      <ChartView
        ref="chartView"
        :podData="podDataForChart"
        :screenWidth="screenWidth"
        v-if="activeView === 'live_data_chart'"
      />
    </keep-alive>
  </div>
</template>

<script>
import ChartView from '@/components/pods/liveData/ChartView'
import DataView from '@/components/pods/liveData/DataView'
import Vue from 'vue'
import moment from 'moment-timezone'

export default {
  props: {
    activeView: {
      type: String,
      default: 'live_data_view'
    }
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      podData: [],
      podDataForChart: [],
      connectionStatus: 2
    }
  },
  mounted() {
    this.initSignalR()
    this.$hub.$on('pod-data-received', this.onPodDataReceived)
    window.addEventListener('resize', this.getScreenWidth)
  },
  components: {
    ChartView,
    DataView
  },
  watch: {
    '$store.state.pods.selectedPod'() {
      this.podData = []
      this.podDataForChart = []
      this.addNewToGroup()
    },
    '$store.state.pods.selectedUtcOffset': function() {
      this.podData = this.podData.map(data => {
        return {
          ...data,
          timeStampWithUtc: moment
            .utc(data.timeStamp)
            .tz(this.$store.state.pods.selectedUtcOffset)
            .format('YYYY-MM-DD HH:mm:ss')
        }
      })
      this.podDataForChart = this.podDataForChart.map(data => {
        return {
          ...data,
          timeStampWithUtc: moment
            .utc(data.timeStamp)
            .tz(this.$store.state.pods.selectedUtcOffset)
            .format('YYYY-MM-DD HH:mm:ss')
        }
      })
    }
  },
  methods: {
    initSignalR() {
      this.connectionStatus = 0
      Vue.prototype
        .startSignalR()
        .then(() => {
          this.connectionStatus = 1
        })
        .catch(() => {
          this.connectionStatus = 2
        })
    },
    addNewToGroup() {
      this.connectionStatus = 0
      Vue.prototype
        .addToGroup()
        .then(() => {
          this.connectionStatus = 1
        })
        .catch(() => {
          this.connectionStatus = 2
        })
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    },
    onPodDataReceived(data) {
      if (data.podMac === this.$store.state.pods.selectedPod.podId) {
        let calculatedData = {
          ...data,
          timeStampWithUtc: moment
            .utc(data.timeStamp)
            .tz(this.$store.state.pods.selectedUtcOffset)
            .format('YYYY-MM-DD HH:mm:ss')
        }
        this.podData.push(calculatedData)

        if (!this.podDataForChart.length) {
          this.podDataForChart.push(calculatedData)
        } else {
          let prevData = this.podDataForChart[this.podDataForChart.length - 1]
          if (data.tickCounter % 2 === 0) {
            this.podDataForChart.push({
              ...calculatedData,
              batteryVoltage: prevData.batteryVoltage,
              temperature: prevData.temperature
            })
          } else {
            this.podDataForChart.push({
              ...calculatedData,
              sensor1Value: prevData.sensor1Value,
              sensor2Value: prevData.sensor2Value,
              ax: prevData.ax,
              ay: prevData.ay,
              az: prevData.az
            })
          }
        }
      }
    }
  },
  destroyed() {
    Vue.prototype.stopSignalR()
  }
}
</script>
